import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {PagesStore, SidebarStore} from '@store/index';
import {Org, UsersStore} from '@store/common/users.store';
import {environment} from '../../../../../environments/environment';
import {User} from '@core/interfaces/common/users';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {filter, takeUntil} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent extends Unsubscribable implements OnInit {
    @Input() currentUser: any;

    constructor(public pagesStore: PagesStore, public sidebarStore: SidebarStore, public userStore: UsersStore) {
        super();
    }

    ngOnInit() {
        this.userStore.currentUser$
            .pipe(
                takeUntil(this.unsubscribe$),
                filter((u) => u && !!u),
            )
            .subscribe((user: User) => {
                const org: Org = this.userStore.checkCurrentOrg(user);
                this.isOrgEii.next(org == Org.EII);
                this.isOrgAlectra.next(org == Org.ALECTRA);
            });
    }

    staging: boolean = environment.STAGING;

    private isOrgEii: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly isOrgEii$: Observable<boolean> = this.isOrgEii.asObservable();

    private isOrgSwi: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly isOrgSwi$: Observable<boolean> = this.isOrgSwi.asObservable();

    private isOrgAlectra: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly isOrgAlectra$: Observable<boolean> = this.isOrgAlectra.asObservable();

    // Hide staging banner for particular tenants
    public hideStagingBanner(user: User): boolean {
        const hideBannerForTenants: string[] = ['atcolfprod'];
        return user?.activeTenantId && hideBannerForTenants.includes(user.activeTenantId);
    }
}
